export interface OutputOptions {
	outputFile?: string;
	force?: boolean;
	quiet?: boolean;
	format?: 'text' | 'json';
}